import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';


export default /*#__PURE__*/_defineComponent({
  __name: 'CLoader',
  props: {
    value: { type: Boolean },
    text: { default: 'Loading...' },
    fullSize: { type: Boolean, default: true },
    zIndex: { default: 99999 }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'input', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: boolean, text: string, fullSize: boolean, zIndex: number };

_useCssVars((_vm, _setup) => ({
  "3b4119b1": (_vm.zIndex)
}))





const isLoading = computed({
    get: () => props.value,
    set: (value: boolean) => emit('input', value)
});

return { __sfc: true,props, emit, isLoading, Loading }
}

})